export const TYPE_NOTICELIST = 10000
export const TYPE_NOTICEDETAIL = 10001
export const TYPE_FAQLIST = 10002
export const TYPE_CENTERSUBMIT = 10003
export const TYPE_TERMSDESC = 10004
export const TYPE_LOGINCERT = 10112
export const TYPE_LOGIN = 10100
export const TYPE_JOIN = 10006
export const TYPE_CANCEL = 10007
export const TYPE_SECURITY = 10008
export const TYPE_CANCEL_SUBMITCAPTCHA = 10009
export const TYPE_CHECK_MVNOMEMBER = 10016
export const TYPE_JOIN_SUBMITCAPTCHA = 10110
export const TYPE_NEWS = 10010
export const TYPE_BIRTHDAY_FORTUNE = 10103
export const TYPE_Horoscope_FORTUNE = 10104
export const TYPE_HealthDataList = 10105
export const TYPE_HealthDetailData =  10106
export const TYPE_LifeDetailData =  10108
export const TYPE_LifeDataList = 10107
export const TYPE_USERPAGE_INFO = 10102
export const TYPE_SESSION = 10111
export const TYPE_LOGOUT = 10101
export const TYPE_USETERMSDESC = 10011
export const TYPE_HOME_TERMS = 10012
export const TYPE_JOIN_TERMS = 10013
export const TYPE_REFUND_TERMS = 10114
export const TYPE_REFUND_SUBMITCAPTCHA = 10115
export const TYPE_REFUND = 10116